// extracted by mini-css-extract-plugin
export default {"btn":"ButtonCustom_btn__O5lsN","scroll":"ButtonCustom_scroll__BRTUb"};